// 1. Enhanced useTour.js with better tour management
import { useDispatch, useSelector } from "react-redux";
import { setActiveTour, setWelcomeModal, setTourStatus } from "./tourActions";

export const useTour = () => {
  const dispatch = useDispatch();
  const tourState = useSelector((state) => state.tour);

  const startTour = (tourType) => {
    if (tourState.activeTour) {
      dispatch(setActiveTour(null));
      setTimeout(() => {
        dispatch(setActiveTour(tourType));
      }, 100);
    } else {
      dispatch(setActiveTour(tourType));
    }
  };

  const showWelcome = () => {
    dispatch(setWelcomeModal(true));
  };

  const hideWelcome = () => {
    dispatch(setWelcomeModal(false));
  };

  const completeTour = (tourType) => {
    dispatch(setTourStatus(tourType, true));
    dispatch(setActiveTour(null));
  };

  const stopTour = () => {
    dispatch(setActiveTour(null));
  };

  const isTourCompleted = (tourType) => {
    return tourState.completedTours.includes(tourType);
  };

  const checkIfNewUser = (user) => {
    if (!user || !user.created_date) return false;

    const accountAge = new Date() - new Date(user.created_date);
    const daysSinceCreation = accountAge / (1000 * 60 * 60 * 24);
    return daysSinceCreation <= 7;
  };

  // Enhanced restart functionality
  const restartTour = (tourType) => {
    stopTour();
    setTimeout(() => {
      startTour(tourType);
    }, 200);
  };

  return {
    ...tourState,
    startTour,
    restartTour,
    showWelcome,
    hideWelcome,
    completeTour,
    stopTour,
    isTourCompleted,
    checkIfNewUser,
  };
};
